import { usePostPlotGroupComparison } from '@/api/rest/resources/organization';
import { IndicatorFactType } from '@/api/rest/resources/types/fact';

export type EditComparisonSubmitProps = {
  id: string | null;
  name: string;
  organizationId: string;
  plotGroupIds: string[];
  indicators?: IndicatorFactType[];
  onSuccess?: () => void;
};

export const useEditComparison = () => {
  const postComparisonMutation = usePostPlotGroupComparison();

  const submit = async ({
    id,
    organizationId,
    name,
    plotGroupIds,
    indicators,
    onSuccess,
  }: EditComparisonSubmitProps) => {
    const newComparison = await postComparisonMutation.mutateAsync({
      pathVariables: { organization_id: organizationId },
      bodyData: {
        id,
        name,
        plot_group_ids: plotGroupIds,
        indicators,
      },
    });

    onSuccess?.();

    return newComparison;
  };

  const isSubmitting = postComparisonMutation.isPending;

  return { submit, isSubmitting };
};
